'use strict';

angular.module('atex.dam').controller('DamAuthorController', ['$rootScope', '$modal', '$state', '$scope', 'AssignService', 'DamService', 'DamAuthorService', 'ContentService', 'DamNotificationService', '$translate', 'UserProfileService', 'configuration',
    function ($rootScope, $modal, $state, $scope, AssignService, DamService, DamAuthorService, ContentService, DamNotificationService, $translate, UserProfileService, configuration) {

        $scope.authors = [];
        $scope.startRows = 0;
        $scope.prevRows = 0;
        $scope.nextRows = 0;
        $scope.numFound = 0;
        $scope.prevSearchFilter = '';
        $scope.msgFound = '';
        $scope.showSpinner = true;
        $scope.disableLoadPrevPage = false;
        $scope.disableLoadNextPage = false;
        $scope.defaultUserAuthorId = undefined;

        $translate(['__GENERIC_ERROR_MSG__', '__OPERATION_COMPLETED_SUCCESSFULLY__']).then(function (translations) {
            $scope.message = {};

            $scope.message.error = translations.__GENERIC_ERROR_MSG__;
            $scope.message.success = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
        });

        var setupFoundMessage = function(response) {
            var authors = response.authors || [];
            var numFound = response.numFound || 0;
            $scope.prevRows = response.prev || 0;
            $scope.nextRows = response.next || 0;
            $scope.disableLoadPrevPage = $scope.startRows <= 0;
            $scope.disableLoadNextPage = (authors.length === 0) || (authors.length >= numFound) || ($scope.nextRows > numFound);
            if (authors.length < numFound) {
                $translate('__AUTHOR_NUMFOUND__', {size: authors.length, numFound: numFound}).then(function(msg) {
                    $scope.msgFound = msg;
                });
            } else {
                $scope.msgFound = '';
            }
        };

        //dynamic filtering result
        $scope.filterAuthors = function () {
            $scope.showSpinner = true;
            if ($scope.searchFilter !== $scope.prevSearchFilter) {
                $scope.startRows = 0;
            }

            var curFilter = $scope.searchFilter;
            return DamAuthorService.searchAuthors({
                start: $scope.startRows,
                filter: curFilter
            }).then(function (response) {
                setupFoundMessage(response);
                $scope.authors = response.authors || [];
                $scope.originalAuthors =  angular.copy($scope.authors);
                $scope.prevSearchFilter = curFilter;
                return DamAuthorService.getUserDefault().then(function(userDefault) {
                    $scope.defaultUserAuthorId = userDefault;
                    for (var i = 0; i < $scope.authors.length; i++) {
                        $scope.authors[i].isDefault = userDefault && ($scope.authors[i].id === userDefault);
                    }
                });
            }).then(null, function (error) {
                var message = $scope.message.error + " (" + error.cause + ")";
                DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
            }).then(function() {
                $scope.showSpinner = false;
            }, function() {
                $scope.showSpinner = false;
            });
        };

        $scope.loadPrevPage = function() {
            $scope.startRows = $scope.prevRows;
            return $scope.filterAuthors();
        };

        $scope.loadNextPage = function() {
            $scope.startRows = $scope.nextRows;
            return $scope.filterAuthors();
        };

        $scope.filterAuthors().then(function () {
            UserProfileService.disableAction({'action': 'edit-authors', 'application': 'desk'}).then(function (disable) {
                $scope.disableEditAuthors = typeof disable !== 'undefined';
            });
        });

        $scope.delete = function (key) {
            DamAuthorService.deleteAuthor($scope.authors[key].id).then(function () {
                    $scope.authors.splice(key, 1);
                }
            );
        };

        $scope.create = function () {
            DamAuthorService.createModal(true, undefined, 'views/dam-author-modal.html', function (response) {
                DamAuthorService.setOwnerDetails(response.data);
                response.data.isOwner = true;
                $scope.authors.push(response.data);
                $scope.originalAuthors =  angular.copy($scope.authors);
            });
        };

        $scope.edit = function (key, id) {

            DamAuthorService.createModal(false,id, 'views/dam-author-modal.html', function (response) {
                DamAuthorService.setOwnerDetails(response.data);
                $scope.authors[key] = response.data;
            });
         };

        $scope.share = function (id) {
            DamAuthorService.createModal(false, id, 'views/dam-assign.html', function (response) {
            });
        };

        $scope.setSelectedRow = function (row) {
            $scope.selectedRow = row;
        };

        $scope.canMakeDefault = function () {
            return $scope.selectedRow !== undefined && !$scope.authors[$scope.selectedRow].isDefault;
        };

        $scope.makeDefault = function () {
            if ($scope.canMakeDefault()) {
                return DamAuthorService.makeDefault($scope.authors, $scope.selectedRow).then(function(author) {
                    if (author && author.id) {
                        $scope.defaultUserAuthorId = author.id;
                    }
                    DamNotificationService.addNotification(atex.dam.Notification({
                        type: 'success',
                        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
                    }), false);
                }, function(error) {
                    console.log('cannot make default author', error);
                    var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
                    DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
                });
            }
        };

        $scope.canRemoveDefault = function () {
            return $scope.defaultUserAuthorId;
        };

        $scope.removeDefault = function() {
            if ($scope.canRemoveDefault()) {
                return DamAuthorService.removeUserDefault().then(function() {
                    $scope.authors.forEach(function(author) {
                        author.isDefault = false;
                    });
                    $scope.defaultUserAuthorId = undefined;
                    DamNotificationService.addNotification(atex.dam.Notification({
                        type: 'success',
                        message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
                    }), false);
                }, function(error) {
                    console.log('cannot remove default author', error);
                    var message = $translate.getTranslationTable().__GENERIC_ERROR_MSG__ + " (" + error.cause + ")";
                    DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
                });
            }
        };

        $scope.isDefault = function (entry) {
            return entry.isDefault;
        };

        $scope.isOwner = function (entry) {
            return entry.isOwner;
        };
        $scope.canShare = function (entry) {
            return $scope.isOwner(entry);
        };
        $scope.canEdit = function (entry) {
            if (configuration.getFilterAuthorsList() === false){
                return !$scope.disableEditAuthors;
            }else{
                return $scope.isOwner(entry);
            }
        };
        $scope.canDelete = function (entry) {
            return $scope.isOwner(entry);
        };
        $scope.isInherited = function (entry) {
            return entry.isInherited;
        };


    }]);